import { FC } from 'react';

import cx from 'classnames';

import Card, { CardProps } from '../Card/Card';
import TabsWithContent, {
  TabsWithContentProps,
} from '../TabsWithContent/TabsWithContent';

const TabsWithContentCard: FC<
  TabsWithContentProps & { cardProps?: CardProps }
> = ({
  tabs = [],
  cardProps = {
    withShadow: true,
    borderRadius: [false, false, '3xl', 'sm'],
    className: 'p-4 mb-4 bg-white',
  },
  ...props
}) => {
  return (
    <TabsWithContent
      tabs={tabs.map(value => ({
        ...value,
        component: (
          <Card
            {...cardProps}
            className={cx('z-10 relative', cardProps?.className)}
          >
            {value.component}
          </Card>
        ),
      }))}
      {...props}
    />
  );
};

export default TabsWithContentCard;
